module.exports = __webpack_public_path__ + "img/explore.8ff725b6.svg";